// extracted by mini-css-extract-plugin
export default {"container":"style_container__21I9e","main":"style_main__aDUYg"};